webpackJsonp([146960199281017],{

/***/ 1621:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/people/marina-guirey/","posts":[{"fields":{"slug":"/news/automechanika-at-the-birmingham-nec/","author":{"id":"/opt/build/repo/src/pages/people/marina-guirey.md absPath of file >>> MarkdownRemark"}},"frontmatter":{"title":"Automechanika at the Birmingham NEC","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 automechanika article header image v1-f1444eb414f4bfcb2c8bd6aa8aac6b04.jpg"}}},"original":"/img/1160x450 automechanika article header image v1.jpg"},"category":"News"}}]},"frontmatter":{"title":"Marina Guirey"}}}]}},"pathContext":{"author":"/people/marina-guirey/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-marina-guirey-500899b72ce5573b1403.js